import { ListItem, UnorderedList } from '@chakra-ui/react';

import { formatAmount } from 'common/formatAmount';
import { FCWithChildren } from 'common/types';
import Text from 'components/_core/Text';
import Tooltip from 'components/_core/Tooltip';

import locales from '../../locales';

interface RevenueTooltipProps {
  vatAmount: number;
  shineRevenue: number;
  complementaryRevenue: number;
  isSubjectToVAT: boolean;
}

const RevenueTooltip: FCWithChildren<RevenueTooltipProps> = ({
  children,
  complementaryRevenue,
  isSubjectToVAT,
  shineRevenue,
  vatAmount,
}) => {
  return (
    <Tooltip
      description={
        <Text color="white" fontSize="font-12" fontWeight="weight-400">
          {locales.overview.tooltip.title}

          <UnorderedList>
            <ListItem>
              {locales.formatString(locales.overview.tooltip.revenue, {
                amount: formatAmount({
                  forcePlusSign: false,
                  value: shineRevenue,
                }),
              })}
            </ListItem>

            <ListItem>
              {locales.formatString(
                locales.overview.tooltip.complementaryRevenue,
                {
                  amount: formatAmount({
                    forcePlusSign: false,
                    value: complementaryRevenue,
                  }),
                },
              )}
            </ListItem>

            {isSubjectToVAT ? (
              <ListItem>
                {locales.formatString(locales.overview.tooltip.vatAmount, {
                  amount: formatAmount({
                    forcePlusSign: false,
                    value: vatAmount,
                  }),
                })}
              </ListItem>
            ) : null}
          </UnorderedList>
        </Text>
      }
    >
      {children}
    </Tooltip>
  );
};

export default RevenueTooltip;
